/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @file The class of OMGH5PageInitEvent
 */

import SequencedEvent from 'com/didichuxing/tracker/plugin/events/SequencedEvent';
import PluginUtils from 'com/didichuxing/tracker/plugin/utils/PluginUtils';

export default class OMGH5PageInitEvent extends SequencedEvent {

    /**
     * @override
     * @inheritDoc
     * @returns {string}
     */
    public getType(): string {
        return PluginUtils.EVENT_ID_PAGE_INIT;
    }
}
